module.exports = __webpack_public_path__ + "img/a-ziyuan7.ea1f3e40.png";